// @ts-nocheck
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { db } from "../../src/firebase/firebase";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

const sanitizeObject = (obj) => {
  return {
    user_id: obj.user_id,
    username: obj.username || "Anonymous",
    profile_picture:
      obj.profile_picture ||
      "https://encrypted-tbn0.gstatic.com/images?q=tb n:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU",
  };
};

const useHandleChat = (user, userDetails, setIsChatLoading) => {
  const navigate = useNavigate();

  const handleChat = async () => {
    setIsChatLoading(true);
    try {
      const currentUserId = user?.user_id?.toString();
      const otherUserId = userDetails?.user_id?.toString();

      if (!currentUserId || !otherUserId) {
        console.error("Error: Missing user IDs");
        toast.error("Missing user IDs");
        return;
      }

      if (!user || !userDetails) {
        console.error("Error: user or userDetails is undefined");
        toast.error("User data is missing");
        return;
      }

      console.log("user:", JSON.stringify(user, null, 2));
      console.log("userDetails:", JSON.stringify(userDetails, null, 2));

      // Query chats where currentUserId is in the 'users' array
      const chatQuery = query(
        collection(db, "chats"),
        where("users", "array-contains", currentUserId)
      );
      const chatSnapshot = await getDocs(chatQuery);

      let existingChat = null;

      chatSnapshot.forEach((doc) => {
        const chatData = doc.data();
        if (chatData.users.includes(otherUserId)) {
          existingChat = { id: doc.id, ...chatData };
        }
      });

      if (existingChat) {
        navigate("/chat-screen", {
          state: {
            chatId: existingChat.id,
            otherUser: userDetails,
            user,
          },
        });
      } else {
        const sanitizedUser = sanitizeObject(user);
        const sanitizedUserDetails = sanitizeObject(userDetails);

        const newChatRef = await addDoc(collection(db, "chats"), {
          users: [currentUserId, otherUserId],
          usersDetails: [sanitizedUser, sanitizedUserDetails],
          lastMessage: null,
          unseenCounts: {
            [currentUserId]: 0,
            [otherUserId]: 0,
          },
          createdAt: serverTimestamp(),
        });

        navigate("/chat-screen", {
          state: {
            chatId: newChatRef.id,
            otherUser: userDetails,
            user,
          },
        });
      }
    } catch (error) {
      console.error("Error handling chat:", error);
      toast.error("Failed to start chat");
    } finally {
      setIsChatLoading(false);
    }
  };

  return handleChat;
};

export default useHandleChat;
